import { FC } from 'react'
import { Box, Grid } from '@mui/material'
import { FinanceInfoDisclaimer } from '../../../../../common/graphql/__generated__/graphql.autogenerated'
import { DisclaimerSection } from '../../../../../common/model/Breakdown'
import DisclaimerValue from './DisclaimerValue'
import disclaimerStyles from './disclaimer.styles'

type DisclaimerProps = {
  disclaimerData: FinanceInfoDisclaimer[] | DisclaimerSection[]
}

const Disclaimer: FC<DisclaimerProps> = ({ disclaimerData }) => {
  const styles = disclaimerStyles()

  return (
    <Grid container data-test="summary:disclaimer-section">
      <Box className={styles.container}>
        {disclaimerData?.map((disclaimer, index) => (
          <DisclaimerValue
            description={
              'value' in disclaimer
                ? disclaimer?.value
                : disclaimer?.description
            }
            key={index}
          />
        ))}
      </Box>
    </Grid>
  )
}

export default Disclaimer
